<template>
  <div>
  <!-- https://joaomede.github.io/vue3-xlsx/guide/#quick-start -->
  <div class="packageOrder-form">
    <p>Wybierz plik Excel i powiąż kolumny z danymi:</p>

    <hr/>

    <section>
      <input
          type="file"
          @change="onFileChange"
          :class="fileInputClass"
          id="packageOrder-file-input"
          aria-describedby="packageOrder-file-input-feedback"
          placeholder="Kliknij aby wybrać plik do importu"
          title="Kliknij aby wybrać plik do importu"
          accept=".xls,.xlsx,.csv,.odf,.ods,.odt,.docx"
      />
      <div class="invalid-feedback" id="packageOrder-file-input-feedback">
        Nie wybrano pliku do importu
      </div>

      <xlsx-read :file="file">
        <xlsx-sheets>
          <template #default="{ sheets }">
            <div v-show="selectSheetVisible" class="row packageOrder-form-row">
              <div class="col">
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">Wybierz arkusz danych</div>
                  </div>
                  <select
                      v-model="selectedSheet"
                      aria-describedby="packageOrder-sheet-input-feedback"
                      @click="sheetIsSelected"
                      :class="selectedSheetInputClass"
                      required
                  >
                    <option disabled selected="selected">
                      Zaimportowane arkusze:
                    </option>
                    <option v-for="sheet in sheets" :key="sheet" :value="sheet">
                      {{ sheet }}
                    </option>
                  </select>
                  <div
                      class="invalid-feedback"
                      id="packageOrder-sheet-input-feedback"
                  >
                    Nie wybrano pliku arkusza danych
                  </div>
                </div>
              </div>
            </div>
          </template>
        </xlsx-sheets>
        <button
            class="btn btn-success"
            @click="parseXlsxData"
            :disabled="importActionButtonDisabled"
        >
          Powiąż pola danych
        </button>
        <hr/>
        <!-- <xlsx-table :sheet="selectedSheet"/> -->
        <div v-if="xlsxDataParsing">
          <xlsx-json :sheet="selectedSheet">
            <template #default="{ collection }">
              <div>
                {{ getXlsxJson(collection) }}
              </div>
            </template>
          </xlsx-json>
        </div>
      </xlsx-read>




    </section>
  </div>


  <div>

    <hr/>

    <div
        class="alert alert-danger"
        role="alert"
        v-show="importedDataErrorDisplayed"
    >
      {{ importedDataErrorMessage }}
    </div>

  </div>

  <!-- Xlsx content table modal -->
  <div v-if="xlsxContentDisplayed" class="modal">
    <div
        class="modal-content"
        ref="packageOrder-bind-modal-form"
        id="packageOrder-bind-modal-form"
    >

      <button class="btn btn-primary" @click="closeFieldsBindingForm">
        Zapisz mapowanie
      </button>
      <h3>Arkusz powiązywania pól danych</h3>
      <hr/>

      <div class="table-responsive">
        <div
            class="alert alert-warning"
            role="alert"
            v-show="duplicatedMappingWarningDisplayed"
        >
          Wykryto zduplikowane wartości mapowanych pól. Bez zmian kolejne
          wartości nadpiszą wcześniejsze mapowanie.
        </div>

        <table class="table table-hover table-bordered">
          <thead>
          <tr>
            <th
                v-for="(recordKey, index) in availableRecordsKeys"
                :key="index"
            >
              <div>
                <select :ref="'field_' + index" @change="getMapping" required>
                  <option
                      v-if="columnMapped(index)"
                      selected="selected"
                      :value="orderFileAvailableKeysMapReversed[columnsMapping[index]]"
                  >
                    {{ columnsMapping[index] }}
                  </option>


                  <option v-else selected="selected" :value="undefined">
                    Przypisz pole...
                  </option>

                  <option
                      v-for="field in orderFileAvailableKeysMap"
                      :key="field"
                      :value="field"
                  >
                    {{ field }}
                  </option>
                </select>
              </div>
              <hr/>
              <div :ref="'jsonKey_' + index">
                {{ availableRecordsKeys[index] }}
                {{ addColumnIndex(index) }}
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="record in records.slice(
                0,
                visibleRecordsCountDuringImport,
              )"
              :key="record"
          >
            <td v-for="key in availableRecordsKeys" :key="key">
              {{ record[key] }}
            </td>
          </tr>
          </tbody>
        </table>
        <button
            type="button"
            class="btn btn-light"
            style="width: 100%; margin-bottom: 10px"
            @click="changeVisibleRecordCount"
        >
          <!--          <font-awesome-icon :icon="chevronIcon"/>-->
          {{ changeVisibleRecordCountButtonValue }}
        </button>
        <br/>
      </div>
      <button
          class="btn btn-danger"
          @click="cancelMapping"
          style="width: 200px"
      >
        Anuluj mapowanie
      </button>
    </div>

  </div>


    <button v-if="applyBtnTitle" class="btn btn-primary" @click="saveData">
     {{ applyBtnTitle }}
    </button>

  </div>

</template>
<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import {XlsxRead, XlsxSheets, XlsxJson} from "vue3-xlsx";
import Swal from "sweetalert2";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {log} from "@/state/pinia/log";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "PackagesOrderExcelImportForm",
  props: {
    applyBtnTitle:String,
    orderToDivide:Boolean,
  },
  emits:['onSave'],
  components: {
    XlsxRead,
    XlsxSheets,
    XlsxJson
  },
  data() {
    return {
      file: null,
      selectedSheet: null,
      sheetName: null,
      sheets: [{name: "SheetOne", data: [{c: 2}]}],
      collection: [{a: 1, b: 2}],
      records: [],
      availableRecordsKeys: [],
      importActionButtonDisabled: true,
      xlsxContentDisplayed: false,
      xlsxDataParsing: false,
      visibleRecordsCountDuringImport: 6,
      changeVisibleRecordCountButtonValue:
          " Pokaż wszystkie importowane rekordy",
      chevronIcon: "chevron-down",
      jsonKeyMapList: [],
      jsonKeyMap: {},
      columnIndexes: [],
      columnsMapping: {},
      duplicatedMappingWarningDisplayed: false,

      fileInputClass: "form-control",
      selectedSheetInputClass: "form-control",

      selectSheetVisible: false,
      importedDataErrorDisplayed: false,
      importedDataErrorMessage: "",

      draggable: false,
      excelFileAvailableKeysMap: {},
      excelFileAvailableKeysMapReversed: {},
      drugstoresReferenceIdMap: {},

      availableFileFormatsToImport: [
        "xls",
        "xlsx",
        "csv"
      ],

    };
  },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    onApplyData(){
      console.log("OnApplyData triggered from PackageOrderExcelImportForm")
      return this.saveData()
    },
  },

  methods: {

    changeVisibleRecordCount() {
      if (this.visibleRecordsCountDuringImport === this.records.length) {
        this.changeVisibleRecordCountButtonValue =
            "  Pokaż wszystkie importowane rekordy";
        this.chevronIcon = "chevron-down";
        this.visibleRecordsCountDuringImport = 6;
      } else {
        this.changeVisibleRecordCountButtonValue =
            "  Pokaż tylko pierwsze rekordy";
        this.chevronIcon = "chevron-up";
        this.visibleRecordsCountDuringImport = this.records.length;
      }
    },
    getXlsxJson(jsonCollection) {
      this.records = null;
      this.records = jsonCollection;
      if (this.records != null) {
        // preparing json data for transforamtion
        var recordsKeysArray = this.records.map((record) =>
            Object.keys(record)
        );
        var recordsKeysCountArray = this.records.map(
            (record) => Object.keys(record).length
        );
        var maxKeysCount = Math.max.apply(null, recordsKeysCountArray);
        for (let i = 0; i < recordsKeysArray.length; i++) {
          if (recordsKeysArray[i].length === maxKeysCount) {
            this.availableRecordsKeys = recordsKeysArray[i];
            break;
          }
        }
      }

      // And when finished
      this.xlsxContentDisplayed = true;
    },
    parseXlsxData() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.initColumnMappingDialog().then(() => {
        this.importedDataErrorDisplayed = false;
        this.xlsxDataParsing = true;
        this.lazyloaderModule.setDisplayLazyLoader(false);
      })
    },
    showXlsxContentTable() {
      this.importedDataErrorDisplayed = false;
      this.xlsxContentDisplayed = true;

    },
    addColumnIndex(index) {
      this.columnIndexes.push(index);
    },
    getMapping() {
      for (var index in this.columnIndexes) {
        var field = this.$refs["field_" + index];

        if (field && field.length > 0) {
          var field0Value = field[0][field[0].selectedIndex].value;
          var fieldToMap = this.excelFileAvailableKeysMapReversed[field0Value];
          var jsonKey = this.$refs["jsonKey_" + index];
          if (jsonKey && jsonKey.length > 0 && jsonKey[0].firstChild) {
            var jsonKeyValue = jsonKey[0].firstChild.data;

            if (fieldToMap && jsonKeyValue) {
              // Adding column mapping to be capable to display it second time when user opens import form for particular import
              this.columnsMapping[index] = field0Value;
              this.checkDuplicatedMapping(fieldToMap);
              this.jsonKeyMap[fieldToMap] = jsonKeyValue.toString().trim();
            }
          }
        }
      }
      log.log("Mapping finished:")
      log.log(this.jsonKeyMap);


    },
    checkDuplicatedMapping(field) {
      if (this.fieldIsAlreadyInObject(field, this.jsonKeyMap)) {
        this.duplicatedMappingWarningDisplayed = true;
      } else {
        this.duplicatedMappingWarningDisplayed = false;
      }
    },
    fieldIsAlreadyInObject(field, obj) {
      for (var i = 0; i < Object.keys(obj).length; i++) {
        if (Object.keys(obj)[i] === field) {
          return true;
        }
      }
      return false;
    },
    columnMapped(index) {
      if (this.columnsMapping[index] !== undefined) {
        return true;
      }

      var matchedValue = this.matchColumnMapping(index);
      if (matchedValue) {
        //get name of column name/drugstore id (it can be found in orderFileAvailableKeysMap)
        var keyFound = this.excelFileAvailableKeysMap[matchedValue]
        this.columnsMapping[index] = keyFound
        var reversedKey = this.excelFileAvailableKeysMapReversed[keyFound]

        const columnFetchedKeyValue = this.availableRecordsKeys[index]
        this.jsonKeyMap[reversedKey] = columnFetchedKeyValue
        return true;
      }


      return false;
    },
    matchColumnMapping(columnIndex) {
      // we are about to check fetched table keys and first two rows if have any values that we can map with available keys
      // 1. Checking columns fetched by ve xlsx lib as column keys
      var keyFound = null;
      const columnFetchedKeyValue = this.availableRecordsKeys[columnIndex]
      var foundValue = null;
      if (columnFetchedKeyValue) {
        keyFound = Object.keys(this.excelFileAvailableKeysMapReversed).find((key) => {
          if (columnFetchedKeyValue.toString().toLowerCase().startsWith(key.toString().toLowerCase())) {
            return key;
          }
        });
        if (keyFound) {
          foundValue = this.excelFileAvailableKeysMapReversed[keyFound];
        }
        if (!foundValue) {
          keyFound = Object.keys(this.drugstoresReferenceIdMap).find((key) => {
            // drugstore reference matching must be precise
            if (key.toString().toLowerCase() === columnFetchedKeyValue.toString().toLowerCase()) {
              return key;
            }
          });
          if (keyFound) {
            foundValue = this.drugstoresReferenceIdMap[keyFound];
          }
        }

        if (foundValue) {
          return foundValue;
        }
      }

      // 2. Checking first row
      const firstRow = this.records[0];
      const keyFirstOnIndex = Object.keys(firstRow)[columnIndex];
      const firstRowOfColIndexValue = firstRow[keyFirstOnIndex];
      foundValue = null;
      if (!firstRowOfColIndexValue) {
        return foundValue;
      }

      keyFound = Object.keys(this.excelFileAvailableKeysMapReversed).find((key) => {
        if (firstRowOfColIndexValue.toString().toLowerCase().startsWith(key.toString().toLowerCase())) {
          return key;
        }
      });
      if (keyFound) {
        foundValue = this.excelFileAvailableKeysMapReversed[keyFound];
      }
      if (!foundValue) {
        keyFound = Object.keys(this.drugstoresReferenceIdMap).find((key) => {
          // drugstore reference matching must be precise
          if (key.toString().toLowerCase() === firstRowOfColIndexValue.toString().toLowerCase()) {
            return key;
          }
        });
        if (keyFound) {
          foundValue = this.drugstoresReferenceIdMap[keyFound];
        }
      }
      // 2. Checking second row
      if (!foundValue) {
        const secondRow = this.records[1];
        const keySecondOnIndex = Object.keys(secondRow)[columnIndex];
        const secondRowOfColIndexValue = secondRow[keySecondOnIndex];
        if (!secondRowOfColIndexValue) {
          return foundValue;
        }


        keyFound = Object.keys(this.excelFileAvailableKeysMapReversed).find((key) => {
          if (secondRowOfColIndexValue.toString().toLowerCase().startsWith(key.toString().toLowerCase())) {
            return key;
          }
        });
        if (keyFound) {
          foundValue = this.excelFileAvailableKeysMapReversed[keyFound];
        }
        if (!foundValue) {
          keyFound = Object.keys(this.drugstoresReferenceIdMap).find((key) => {
            // drugstore reference matching must be precise
            if (key.toString().toLowerCase() === secondRowOfColIndexValue.toString().toLowerCase()) {
              return key;
            }
          });
          if (keyFound) {
            foundValue = this.drugstoresReferenceIdMap[keyFound];
          }
        }
      }

      return foundValue;

    },
    saveData() {
      var isValid = this.checkForm();
      if (isValid) {
        // adding header row as data row - we do not want to avoid first row of excel file
        if (this.records.length > 0) {
          var headerRowAsDataRow = {};
          for (const headerKey of Object.keys(this.records[0])) {
            headerRowAsDataRow[headerKey] = headerKey;
          }
          this.records.push(headerRowAsDataRow);
        }

        var drugstoresOrderItems = []
        //Transforming row data
        for (const recordIndex in this.records) {
          // Clearing every record object keys from empty spacies
          for (const recordKey in this.records[recordIndex]) {
            var oldKey = recordKey;
            var newKey = recordKey.toString().trim();
            if (oldKey !== newKey) {
              Object.defineProperty(
                  this.records[recordIndex],
                  newKey,
                  Object.getOwnPropertyDescriptor(this.records[recordIndex], oldKey)
              );
              delete this.records[recordIndex][oldKey];
            }
          }

          var orderItemObject = {};
          for (const jsonKey in this.jsonKeyMap) {
            // log.log(`${jsonKey} = ${this.jsonKeyMap[jsonKey]}`);
            var originalObject = this.records[recordIndex];
            var value =
                originalObject[this.jsonKeyMap[jsonKey].toString().trim()];
            if (value) {
              if (this.valueIsNotNumber(value)) {
                orderItemObject[jsonKey] = value;
              } else {
                // value is a number, so let`s check what kind of number is it, and cast it into correct type
                if (
                    /^\d*[.]\d+$/.test(value.toString()) ||
                    /^\d*[,]\d+$/.test(value.toString())
                ) {
                  orderItemObject[jsonKey] = parseFloat(value.toString());
                } else {
                  orderItemObject[jsonKey] = parseInt(value.toString());
                }
              }
              orderItemObject["listIndex"] = recordIndex
            }
          }


          //Validating number type fields values
          if (
              orderItemObject["discount"] &&
              this.valueIsNotNumber(orderItemObject["discount"])
          ) {
            orderItemObject["discount"] = 0.0;
          }


          // Validating drugstore item amounts and creating separate objects for every drugstore


          const drugstoreDistinctIds = new Set(Object.values(this.drugstoresReferenceIdMap))
          for (const drugstoreId of drugstoreDistinctIds) {
            if (
                orderItemObject[drugstoreId] &&
                this.valueIsNotNumber(orderItemObject[drugstoreId])
            ) {
              orderItemObject[drugstoreId] = 0.0;

            }

            const itemNameValue = orderItemObject["productName"] ? orderItemObject["productName"].toString().toUpperCase() : null;
            const itemNameJsonKeyValue = this.jsonKeyMap["productName"] ? this.jsonKeyMap["productName"].toString().toUpperCase() : null;
            const itemNameKeyEqValue = itemNameValue != null && itemNameJsonKeyValue != null && itemNameValue === itemNameJsonKeyValue

            const itemBlozValue = orderItemObject["bloz"] ? orderItemObject["bloz"].toString().toUpperCase() : null;
            const itemBlozJsonKeyValue = this.jsonKeyMap["bloz"] ? this.jsonKeyMap["bloz"].toString().toUpperCase() : null;
            const itemBlozKeyEqValue = itemBlozValue != null && itemBlozJsonKeyValue != null && itemBlozValue === itemBlozJsonKeyValue

            const itemDiscountValue = orderItemObject["discount"] ? orderItemObject["discount"].toString().toUpperCase() : null;
            const itemDiscountJsonKeyValue = this.jsonKeyMap["discount"] ? this.jsonKeyMap["discount"].toString().toUpperCase() : null;
            const itemDiscountKeyEqValue = itemDiscountValue != null && itemDiscountJsonKeyValue != null && itemDiscountValue === itemDiscountJsonKeyValue


            if (itemNameKeyEqValue || itemBlozKeyEqValue || itemDiscountKeyEqValue) {
              //means that current parsed row most probably is header row, so we can omit it
              continue;
            }

            const drugstoreOrderItem = {
              drugstoreClientId: parseInt(drugstoreId),
              listIndex: parseInt(orderItemObject["listIndex"]),
              name: orderItemObject["productName"],
              bloz: orderItemObject["bloz"],
              ean: orderItemObject["ean"],
              centralBloz: orderItemObject["bloz"],
              amount: orderItemObject[drugstoreId],
              discount: orderItemObject["discount"]
            };

            // Adding parsed order item to list
            drugstoresOrderItems.push(drugstoreOrderItem)
          }


        }



        var exportPayload = {
          items: drugstoresOrderItems,
          file: this.file
        };

        this.$emit("onSave",exportPayload)
        return exportPayload;
      }
      return null;
    },

    checkForm() {
      var isValid = true;
      var notValidFieldsCount = 0;

      if (!this.file) {
        this.fileInputClass = "form-control is-invalid";
        notValidFieldsCount++;
      } else {
        this.fileInputClass = "form-control";
      }

      if (!this.selectedSheet) {
        this.selectedSheetInputClass = "form-control is-invalid";
        notValidFieldsCount++;
      } else {
        this.selectedSheetInputClass = "form-control";
      }

      if (this.records.length === 0) {
        this.importedDataErrorDisplayed = true;
        this.importedDataErrorMessage = "Brak danych w arkuszu";
        notValidFieldsCount++;
      } else {
        this.importedDataErrorDisplayed = false;
        this.importedDataErrorMessage = "";
      }
      if (!this.jsonKeyMap || Object.keys(this.jsonKeyMap).length === 0) {
        this.importedDataErrorDisplayed = true;
        this.importedDataErrorMessage =
            "Nie powiązano żadnych pól w zaimportowanych danych";

        notValidFieldsCount++;
      } else {
        this.importedDataErrorDisplayed = false;
        this.importedDataErrorMessage = "";
      }

      if (notValidFieldsCount > 0) {
        isValid = false;
      } else {
        isValid = true;
      }

      return isValid;
    },
    valueIsNotNumber(value) {
      if (value === null || value === undefined) {
        value = 0.0;
      }

      if (value.toString()[0] === "-") {
        return (
            !/^[-]\d*[.]\d+$/.test(value.toString()) &&
            !/^[-]\d*[,]\d+$/.test(value.toString()) &&
            !/^[-]\d+$/.test(value.toString())
        );
      } else {
        return (
            !/^\d*[.]\d+$/.test(value.toString()) &&
            !/^\d*[,]\d+$/.test(value.toString()) &&
            !/^\d+$/.test(value.toString())
        );
      }
    },

    onFileChange(event) {
      var fileToParse = event.target.files ? event.target.files[0] : null;
      var fileFormat = this.getFileFormat(fileToParse);
      this.file = fileToParse;
      this.validateFileFormat(fileToParse, fileFormat);
      // Reseting all fields
      this.sheetName = null;
      this.selectedSheet = null;
      this.sheets = [{name: "SheetOne", data: [{c: 2}]}];
      this.collection = [{a: 1, b: 2}];
      this.records = [];
      this.xlsxDataParsing = false;
      this.availableRecordsKeys = [];
      this.importActionButtonDisabled = true;
      this.xlsxContentDisplayed = false;
      this.selectSheetVisible = true;
      this.fileInputClass = "form-control";
      this.jsonKeyMap = {};
      this.columnsMapping = {};
    },

    validateFileFormat(file, fileFormat) {
      if (file != null && file.name.length > 0) {
        var formatAvailable = this.isFileFormatAvailable(fileFormat);
        if (!formatAvailable) {
          Swal.fire(
              "Format pliku jest nieprawidłowy!",
              "Dopuszczalne formaty plików to: " +
              this.availableFileFormatsToImport,
              "error"
          );
          file = null;
        }
      }
    },
    getFileFormat(file) {
      var fileNameElements = file.name.split(".");
      const lastElementIndex = fileNameElements.length - 1;
      var fileFormat = fileNameElements[lastElementIndex];
      return fileFormat;
    },
    isFileFormatAvailable(fileFormat) {
      var formatAvailable = false;
      for (var i = 0; i < this.availableFileFormatsToImport.length; i++) {
        if (
            this.availableFileFormatsToImport[i].toLowerCase() ===
            fileFormat.toLowerCase()
        ) {
          formatAvailable = true;
          break;
        }
      }
      return formatAvailable;
    },
    sheetIsSelected() {
      this.importActionButtonDisabled = false;
    },
    addSheet() {
      this.sheets.push({name: this.sheetName, data: [...this.collection]});
      this.sheetName = null;
    },

    closeFieldsBindingForm() {
      this.xlsxContentDisplayed = false;
      this.xlsxDataParsing = false;
      log.log("Zapisuję mapowanie...")
      log.log(this.jsonKeyMap)
    },
    cancelMapping() {
      this.columnsMapping = {};
      this.closeFieldsBindingForm();
    },

    reverseObjectKeyValue(data) {
      return Object.fromEntries(
          Object
              .entries(data)
              .map(([key, value]) => [value, key])
      );
    },
    initColumnMappingDialog() {
      const keyMapPayload = {
        toDivide: this.orderToDivide
      }

      return this.packagesModule.httpGetOrderFileKeyMap(keyMapPayload)
          .then((response) => {
            this.orderFileAvailableKeysMap = JSON.parse(JSON.stringify(response.data.payload));
            this.orderFileAvailableKeysMapReversed = this.reverseObjectKeyValue(this.excelFileAvailableKeysMap);

            this.commonModule.httpGetDrugstoresReferenceIdMap()
                .then((response) => {
                  this.drugstoresReferenceIdMap = JSON.parse(JSON.stringify(response.data.payload));
                })
                .catch((error) => {
                  apiRequestsHelper.catchResponseError(error, "httpGetDrugstoresReferenceIdMap");
                });
          })
          .catch((error) => {
            apiRequestsHelper.catchResponseError(error, "httpGetOrderFileKeyMap");
          });
    },

  },
    created() {
      // Reseting all fields
      this.sheetName = null;
      this.selectedSheet = null;
      this.sheets = [{name: "SheetOne", data: [{c: 2}]}];
      this.collection = [{a: 1, b: 2}];
      this.records = [];
      this.xlsxDataParsing = false;
      this.availableRecordsKeys = [];
      this.importActionButtonDisabled = true;
      this.xlsxContentDisplayed = false;
      this.file = null;
      this.selectSheetVisible = true;
      this.jsonKeyMap = {};


      if (this.commonModule.centralInstance) {
        this.orderIsCentral = true
      } else {
        this.orderIsCentral = false
      }

      this.commonModule.httpGetDrugstoresNameMap();


    },

};
</script>

<style scoped>
.packageOrder-form {
  -webkit-box-shadow: 0px 0px 4px -2px #a0a0a0;
  box-shadow: 0px 0px 4px -2px #a0a0a0;
  margin: 10px;
  padding: 15px;
}

.packageOrder-form-row {
  margin-bottom: 10px;
}

.packageOrder-form-submit-row {
  width: 200px;
  padding-top: 40px;
  margin-bottom: 20px;
  margin: 5px;
}

.close-form {
  float: right;
  color: #a0a0a0;
  font-weight: 800;
}

/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 3; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  border: 1px solid #888;
  width: 80%; /* Could be more or less, depending on screen size */
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>
